import { render, staticRenderFns } from "./NovedadesGrid.vue?vue&type=template&id=041995d9&"
import script from "./NovedadesGrid.vue?vue&type=script&lang=js&"
export * from "./NovedadesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports